export const View = () => {
  return <>You Need To Create A Merchant Account. Click here to continue...</>;
};
